/**
 * RC Collection List - JavaScript
 * Handles scroll-spy, details panel, and Ajax cart
 */

(function() {
  'use strict';

  // Get products data
  var productsDataEl = document.getElementById('rc-products-data');
  var productsData = productsDataEl ? JSON.parse(productsDataEl.textContent) : { products: [] };
  var products = productsData.products || [];

  // Elements
  var detailsPanel = document.getElementById('rc-details-panel');
  var detailsContent = document.getElementById('rc-details-content');
  var cartToast = document.getElementById('rc-cart-toast');
  var sidebarBtns = document.querySelectorAll('.rc-sidebar-btn');
  var sections = document.querySelectorAll('.rc-collection-section');
  var productRows = document.querySelectorAll('.rc-product-row');

  // Current state
  var currentProductHandle = null;
  var selectedVariantId = null;
  var toastTimeout = null;

  // Filter state
  var activeFilters = {
    category: '',
    material: '',
    price: ''
  };

  // Material filter test mappings
  // Base list of 12 tests that apply to most materials
  var baseTestList = [
    'melt-flow-index',
    'tensile-strength',
    'flexural-modulus',
    'izod-impact',
    'charpy-impact',
    'vicat-softening-temperature',
    'dsc-melting-crystallinity',
    'ul-94',
    'escr',
    'ash-content',
    'moisture-content',
    'colour',
    'density'
  ];

  // Material-specific test lists
  var materialTestLists = {
    'polyolefins': baseTestList,
    'thermoplastics': baseTestList,
    'eng-plastics': baseTestList,
    'styrenics': baseTestList,
    'vinyl-rigid': baseTestList,
    'vinyl-flexible': baseTestList.filter(function(t) { return t !== 'melt-flow-index'; }).concat(['hardness']),
    'specialty-pet-only': baseTestList.filter(function(t) { return t !== 'melt-flow-index'; }),
    'specialty-excl-pet': baseTestList,
    'recycled': baseTestList
  };

  // Material options per test - based on applicable materials from PDF
  var testMaterialOptions = {
    // Rheological / Flow
    'melt-flow-index': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PET (Engineering)', 'TPE/TPU'],
    'spiral-flow': ['PP', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS'],

    // Mechanical
    'tensile-strength': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET (Engineering)', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],
    'flexural': ['PP', 'HDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PET (Engineering)'],
    'izod-impact': ['PP', 'HDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PET (Engineering)'],
    'charpy-impact': ['PP', 'HDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PET (Engineering)'],
    'hardness': ['PP (Shore D)', 'HDPE (Shore D)', 'LDPE (Shore D)', 'PC (Shore D)', 'PA6/PA66 (Shore D)', 'PBT (Shore D)', 'POM (Shore D)', 'ABS (Shore D)', 'PS/GPPS (Shore D)', 'HIPS (Shore D)', 'PVC Rigid (Shore D)', 'PVC Flexible (Shore A)', 'TPE (Shore A)', 'TPU (Shore A)', 'TPE (Shore D)', 'TPU (Shore D)'],

    // Thermal
    'dsc': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET (Bottle)', 'PET (Engineering)', 'PETG', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)'],
    'tga': ['PP-Filled (Talc/CaCO₃)', 'HDPE', 'PC', 'PA6-GF', 'PA66-GF', 'PBT-GF', 'POM (Acetal)', 'ABS', 'PVC Rigid', 'PVC Flexible', 'PET', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)'],
    'hdt': ['PP', 'PP-GF', 'HDPE', 'PC', 'PA6/PA66', 'PA6-GF', 'PA66-GF', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'PVC Rigid', 'PET', 'PET-GF'],
    'heat-deflection': ['PP', 'PP-GF', 'HDPE', 'PC', 'PA6/PA66', 'PA6-GF', 'PA66-GF', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'PVC Rigid', 'PET', 'PET-GF'],
    'vicat': ['PP', 'HDPE', 'PC', 'PA6/PA66', 'PBT', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'PVC Rigid', 'PET'],
    'oit': ['PP (Stabilized)', 'HDPE (Pipe)', 'LDPE/LLDPE', 'PA6/PA66', 'POM (Acetal)', 'rPP (Recycled PP)', 'rPE (Recycled PE)'],
    'oxidative-induction': ['PP (Stabilized)', 'HDPE (Pipe)', 'LDPE/LLDPE', 'PA6/PA66', 'POM (Acetal)', 'rPP (Recycled PP)', 'rPE (Recycled PE)'],

    // Physical
    'density': ['PP', 'HDPE', 'MDPE', 'LDPE', 'LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)'],
    'moisture': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET', 'PETG', 'TPU'],
    'shrinkage': ['PP', 'HDPE', 'LDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PET'],
    'colour': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET (Engineering)', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],

    // Chemical / Identification
    'ftir': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PBT', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],
    'ash-content': ['PP-Talc', 'PP-CaCO₃', 'HDPE', 'PA6-GF', 'PA66-GF', 'PBT-GF', 'PVC Rigid', 'PVC Flexible', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],

    // Flammability
    'ul-94': ['PP', 'PP-FR', 'HDPE', 'LDPE', 'PC', 'PA6/PA66', 'PA6-FR', 'PA66-FR', 'PBT', 'PBT-FR', 'ABS', 'ABS-FR', 'PS/GPPS', 'PVC Rigid', 'PVC Flexible'],
    'ul94': ['PP', 'PP-FR', 'HDPE', 'LDPE', 'PC', 'PA6/PA66', 'PA6-FR', 'PA66-FR', 'PBT', 'PBT-FR', 'ABS', 'ABS-FR', 'PS/GPPS', 'PVC Rigid', 'PVC Flexible'],
    'glow-wire': ['PA66-GF (FR)', 'PBT-GF (FR)', 'PC-FR', 'PA6-GF (FR)'],
    'gwfi': ['PA66-GF (FR)', 'PBT-GF (FR)', 'PC-FR', 'PA6-GF (FR)'],
    'gwit': ['PA66-GF (FR)', 'PBT-GF (FR)', 'PC-FR', 'PA6-GF (FR)'],

    // Processing
    'escr': ['HDPE', 'LDPE/LLDPE', 'PP', 'PC', 'ABS', 'PS/GPPS'],
    'injection': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],
    'extrusion': ['HDPE (Pipe)', 'LDPE/LLDPE (Film)', 'PP (Fiber/Film)', 'PVC (Profile/Pipe)', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],
    'weld-line': ['PP', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS'],
    'reprocessing': ['rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],

    // Advanced
    'microscopy': ['PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF', 'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible', 'PET', 'TPE/TPU', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'],
    'sem': ['PP', 'HDPE', 'PC', 'PA-GF (Glass Filled)', 'PBT-GF', 'ABS', 'PVC Rigid', 'PVC Flexible', 'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate']
  };

  // Default material list for tests not specifically mapped
  var defaultMaterialOptions = [
    'PP', 'HDPE', 'LDPE/LLDPE', 'PC', 'PA6/PA66', 'PA-GF (Glass Filled)', 'PBT/PBT-GF',
    'POM (Acetal)', 'ABS', 'PS/GPPS', 'HIPS', 'PVC Rigid', 'PVC Flexible',
    'PET (Bottle)', 'PET (Engineering)', 'TPE/TPU',
    'rPP (Recycled PP)', 'rPE (Recycled PE)', 'rPET (Recycled PET)', 'rABS (Recycled ABS)', 'Mixed Recyclate'
  ];

  // Package material options - each package has specific applicable materials
  var packageMaterialOptions = {
    // QUICK - 2-Test Quick Check (MFI + Density)
    'quick': ['PP (All Types)', 'HDPE', 'LDPE/LLDPE', 'POM (Acetal)', 'PS/GPPS', 'PVC Rigid'],
    '2-test-quick-check': ['PP (All Types)', 'HDPE', 'LDPE/LLDPE', 'POM (Acetal)', 'PS/GPPS', 'PVC Rigid'],

    // PC-QUICK - PC Moisture Quick Check (MFI + Moisture)
    'pc-quick': ['PC (Polycarbonate)'],
    'pc-moisture-quick-check': ['PC (Polycarbonate)'],

    // PA-QUICK - PA ID + Moisture Check (MFI + Moisture + DSC)
    'pa-quick': ['PA6/PA66 (Nylon)'],
    'pa-id-moisture-check': ['PA6/PA66 (Nylon)'],

    // PAGF-QUICK - PA-GF Verification (MFI + Moisture + Ash)
    'pagf-quick': ['PA-GF (Glass-Filled Nylon)'],
    'pa-gf-verification': ['PA-GF (Glass-Filled Nylon)'],

    // PBT-QUICK - PBT Quick Check (MFI + Density + Moisture)
    'pbt-quick': ['PBT', 'PBT-GF'],
    'pbt-quick-check': ['PBT', 'PBT-GF'],

    // IMPACT-QUICK - Flow + Impact Check (MFI + Impact)
    'impact-quick': ['ABS', 'HIPS'],
    'flow-impact-check': ['ABS', 'HIPS'],

    // HARDNESS-QUICK - Elastomer Grade Check (Hardness + Density)
    'hardness-quick': ['PVC Flexible', 'TPE/TPU'],
    'elastomer-grade-check': ['PVC Flexible', 'TPE/TPU'],

    // PET-QUICK - PET Moisture Critical (Moisture + DSC)
    'pet-quick': ['PET (Bottle Grade)', 'PET (Engineering Grade)'],
    'pet-moisture-critical': ['PET (Bottle Grade)', 'PET (Engineering Grade)'],

    // PE-PIPE - PE Pipe Critical Check (MFI + Density + OIT)
    'pe-pipe': ['HDPE (Pipe Applications)'],
    'pe-pipe-critical-check': ['HDPE (Pipe Applications)']
  };

  /**
   * Get material options for a specific product handle
   */
  function getMaterialOptionsForProduct(handle) {
    // Check each key in testMaterialOptions to see if handle contains it
    for (var testKey in testMaterialOptions) {
      if (handle.indexOf(testKey) !== -1) {
        return testMaterialOptions[testKey];
      }
    }
    // Return default list if no specific mapping found
    return defaultMaterialOptions;
  }

  // Selected material for cart
  var selectedMaterial = null;

  // Elements for filtering
  var collectionGrid = document.querySelector('.rc-collection-grid');
  var clearFiltersBtn = document.getElementById('rc-clear-filters');
  var productCountEl = document.getElementById('rc-product-count');

  /**
   * Scroll to a collection section
   */
  window.rcScrollToSection = function(handle) {
    var section = document.getElementById('section-' + handle);
    if (section) {
      var offset = 100; // Account for sticky header
      var top = section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  /**
   * Update active sidebar button based on scroll percentage
   */
  function updateActiveSidebar() {
    var allSections = document.querySelectorAll('.rc-collection-section:not(.hidden)');
    var allBtns = document.querySelectorAll('.rc-sidebar-btn');

    if (allSections.length === 0) return;

    // Calculate scroll percentage
    var scrollTop = window.scrollY;
    var docHeight = document.documentElement.scrollHeight;
    var winHeight = window.innerHeight;
    var scrollableHeight = docHeight - winHeight;

    // Avoid division by zero
    if (scrollableHeight <= 0) {
      scrollableHeight = 1;
    }

    var scrollPercent = scrollTop / scrollableHeight;

    // Map percentage to section index
    var sectionIndex = Math.floor(scrollPercent * allSections.length);

    // Clamp to valid range (ensure last item activates at 100%)
    if (scrollPercent >= 0.99) {
      sectionIndex = allSections.length - 1;
    }
    sectionIndex = Math.max(0, Math.min(sectionIndex, allSections.length - 1));

    // Get the active section handle
    var activeSection = allSections[sectionIndex].dataset.section;

    // Update sidebar buttons
    allBtns.forEach(function(btn) {
      btn.classList.remove('active');
      if (btn.dataset.collection === activeSection) {
        btn.classList.add('active');
      }
    });
  }

  /**
   * Show product details in the panel
   */
  window.rcShowDetails = function(handle) {
    var product = products.find(function(p) { return p.handle === handle; });
    if (!product) return;

    currentProductHandle = handle;

    // For multi-variant products, don't pre-select; for single variant, select it
    var hasMultipleVariants = product.variants.length > 1;
    selectedVariantId = hasMultipleVariants ? null : product.variant_id;

    // All tests and packages require material selection
    var requiresMaterial = true;
    // Use package material options for packages, test material options for tests
    var productMaterialOptions = product.is_package
      ? getPackageMaterialOptions(handle)
      : getMaterialOptionsForProduct(handle);
    selectedMaterial = null;

    // Mark active row
    productRows.forEach(function(row) {
      row.classList.remove('active');
      if (row.dataset.productHandle === handle) {
        row.classList.add('active');
      }
    });

    // Build variants HTML - dropdown for multi-variant products
    var variantsHtml = '';
    if (hasMultipleVariants) {
      variantsHtml = '<div class="rc-details-variants">' +
        '<div class="rc-details-variants-label">Select Option</div>' +
        '<select class="rc-variant-select" id="rc-variant-select" onchange="rcSelectVariantDropdown(this)">' +
        '<option value="" disabled selected>Choose an option...</option>';

      product.variants.forEach(function(variant) {
        variantsHtml += '<option value="' + variant.id + '" data-price="' + variant.price + '">' +
          variant.title + '</option>';
      });

      variantsHtml += '</select></div>';
    }

    // Build material selection HTML - for all tests with applicable materials
    var materialHtml = '';
    if (requiresMaterial && productMaterialOptions.length > 0) {
      materialHtml = '<div class="rc-details-material">' +
        '<div class="rc-details-variants-label">Select Material Type</div>' +
        '<select class="rc-variant-select" id="rc-material-select" onchange="rcSelectMaterial(this)">' +
        '<option value="" disabled selected>Choose a material...</option>';

      productMaterialOptions.forEach(function(material) {
        materialHtml += '<option value="' + material + '">' + material + '</option>';
      });

      materialHtml += '</select></div>';
    }

    // Determine if Add to Cart should be disabled
    // Only require material if there are material options for this product
    var hasMaterialOptions = productMaterialOptions.length > 0;
    var needsSelection = hasMultipleVariants || (requiresMaterial && hasMaterialOptions);

    // Calculate savings for packages
    var savingsHtml = '';
    var comparePriceHtml = '';
    if (product.is_package && product.compare_at_price_raw && product.compare_at_price_raw > product.price_raw) {
      var savings = product.compare_at_price_raw - product.price_raw;
      var savingsPercent = Math.round((savings / product.compare_at_price_raw) * 100);
      savingsHtml = '<span class="rc-savings-badge">Save ' + savingsPercent + '%</span>';
      comparePriceHtml = '<span class="rc-details-compare-price">' + product.compare_at_price + '</span>';
    }

    // Build details HTML
    var html = '' +
      '<div class="rc-details-image">' +
        (product.image ? '<img src="' + product.image + '" alt="' + product.title + '">' : '') +
      '</div>' +
      '<span class="rc-details-badge">' + product.collection + '</span>' +
      '<div class="rc-details-title-wrap">' +
        '<h2 class="rc-details-title">' + product.title + '</h2>' +
        savingsHtml +
      '</div>' +
      '<div class="rc-details-price-wrap">' +
        '<div class="rc-details-price" id="rc-details-price">' +
          (product.price_raw === 0 ? 'Contact for Quote' : product.price) +
        '</div>' +
        comparePriceHtml +
      '</div>' +
      '<div class="rc-details-description">' + product.description + '</div>' +
      variantsHtml +
      materialHtml +
      '<div class="rc-details-actions">' +
        '<button class="rc-details-add-btn" id="rc-add-to-cart-btn" onclick="rcAddToCartFromPanel()" ' +
          'data-requires-variant="' + hasMultipleVariants + '" ' +
          'data-requires-material="' + (requiresMaterial && hasMaterialOptions) + '" ' +
          (product.available && !needsSelection ? '' : 'disabled') + '>' +
          (product.available ? (needsSelection ? 'Select options above' : 'Add to Cart') : 'Unavailable') +
        '</button>' +
      '</div>';

    detailsContent.innerHTML = html;

    // Show panel on mobile
    if (window.innerWidth <= 1024) {
      detailsPanel.classList.add('mobile-open');
      document.body.style.overflow = 'hidden';
    }

  };

  /**
   * Close details panel (mobile)
   */
  window.rcCloseDetails = function() {
    detailsPanel.classList.remove('mobile-open');
    document.body.style.overflow = '';

    productRows.forEach(function(row) {
      row.classList.remove('active');
    });

    currentProductHandle = null;
  };

  /**
   * Select a variant (legacy button method)
   */
  window.rcSelectVariant = function(btn) {
    var buttons = btn.parentElement.querySelectorAll('.rc-variant-btn');
    buttons.forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');

    selectedVariantId = parseInt(btn.dataset.variantId);

    var priceEl = document.getElementById('rc-details-price');
    if (priceEl) {
      priceEl.textContent = btn.dataset.price;
    }
  };

  /**
   * Select a variant from dropdown
   */
  window.rcSelectVariantDropdown = function(select) {
    var selectedOption = select.options[select.selectedIndex];

    if (selectedOption.value) {
      selectedVariantId = parseInt(selectedOption.value);

      // Update price display
      var priceEl = document.getElementById('rc-details-price');
      if (priceEl && selectedOption.dataset.price) {
        priceEl.textContent = selectedOption.dataset.price;
      }

      // Check if we can enable Add to Cart
      updateAddToCartButton();
    }
  };

  /**
   * Select a material from dropdown
   */
  window.rcSelectMaterial = function(select) {
    var selectedOption = select.options[select.selectedIndex];

    if (selectedOption.value) {
      selectedMaterial = selectedOption.value;

      // Check if we can enable Add to Cart
      updateAddToCartButton();
    }
  };

  /**
   * Update Add to Cart button state based on selections
   */
  function updateAddToCartButton() {
    var addBtn = document.getElementById('rc-add-to-cart-btn');
    if (!addBtn) return;

    var requiresVariant = addBtn.dataset.requiresVariant === 'true';
    var requiresMaterial = addBtn.dataset.requiresMaterial === 'true';

    var variantOk = !requiresVariant || selectedVariantId !== null;
    var materialOk = !requiresMaterial || selectedMaterial !== null;

    if (variantOk && materialOk) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Select options above';
    }
  }

  /**
   * Add to cart from panel
   */
  window.rcAddToCartFromPanel = function() {
    if (selectedVariantId) {
      rcAddToCart(selectedVariantId, selectedMaterial);
    }
  };

  /**
   * Add to cart (Ajax)
   */
  window.rcAddToCart = function(variantId, material) {
    var item = {
      id: variantId,
      quantity: 1
    };

    // Add material as line item property if selected
    if (material) {
      item.properties = {
        'Material Type': material
      };
    }

    var formData = {
      items: [item]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      return response.json();
    })
    .then(function(data) {
      showCartToast();
      updateCartCount();
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      alert('Could not add to cart. Please try again.');
    });
  };

  /**
   * Show cart toast notification
   */
  function showCartToast() {
    if (toastTimeout) {
      clearTimeout(toastTimeout);
    }

    cartToast.classList.add('show');

    toastTimeout = setTimeout(function() {
      cartToast.classList.remove('show');
    }, 4000);
  }

  /**
   * Update cart count in header (if element exists)
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.cart-count, [data-cart-count]');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
      });
  }

  /**
   * Click on product row to show details
   */
  productRows.forEach(function(row) {
    row.addEventListener('click', function(e) {
      // Don't trigger if clicking a button
      if (e.target.closest('button')) return;

      var handle = row.dataset.productHandle;
      if (handle) {
        rcShowDetails(handle);
      }
    });
  });

  /**
   * Scroll listener for sidebar active state
   */
  var scrollThrottle = null;
  window.addEventListener('scroll', function() {
    if (scrollThrottle) return;

    scrollThrottle = setTimeout(function() {
      updateActiveSidebar();
      scrollThrottle = null;
    }, 100);
  });

  // Initial sidebar state
  updateActiveSidebar();

  /**
   * Check URL parameters for pre-selected filters
   */
  function checkUrlParams() {
    var urlParams = new URLSearchParams(window.location.search);
    var categoryParam = urlParams.get('category');

    if (categoryParam) {
      // Set the category filter
      activeFilters.category = categoryParam;

      // Update the category dropdown button to show active state
      var categoryBtn = document.querySelector('.rc-filter-dropdown:first-child .rc-filter-btn');
      if (categoryBtn) {
        categoryBtn.classList.add('active');
      }

      // Update the selected state in dropdown
      var categoryItems = document.querySelectorAll('#dropdown-category .rc-dropdown-item');
      categoryItems.forEach(function(item) {
        item.classList.remove('selected');
        if (item.dataset.value === categoryParam) {
          item.classList.add('selected');
        }
      });

      // Apply the filter
      applyFilters();

      // Scroll to the section
      setTimeout(function() {
        rcScrollToSection(categoryParam);
      }, 100);
    }
  }

  // Check URL params on page load
  checkUrlParams();

  /**
   * Toggle dropdown menu
   */
  window.rcToggleDropdown = function(type) {
    var dropdown = document.getElementById('dropdown-' + type);
    var allDropdowns = document.querySelectorAll('.rc-dropdown-menu');

    // Close other dropdowns
    allDropdowns.forEach(function(d) {
      if (d.id !== 'dropdown-' + type) {
        d.classList.remove('open');
      }
    });

    // Toggle this dropdown
    dropdown.classList.toggle('open');
  };

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.rc-filter-dropdown')) {
      document.querySelectorAll('.rc-dropdown-menu').forEach(function(d) {
        d.classList.remove('open');
      });
    }
  });

  /**
   * Handle filter selection
   */
  document.querySelectorAll('.rc-dropdown-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var filterType = this.dataset.filter;
      var filterValue = this.dataset.value;

      // Update active state
      activeFilters[filterType] = filterValue;

      // Update button appearance
      var parentDropdown = this.closest('.rc-filter-dropdown');
      var btn = parentDropdown.querySelector('.rc-filter-btn');
      if (filterValue) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }

      // Update selected state in dropdown
      parentDropdown.querySelectorAll('.rc-dropdown-item').forEach(function(i) {
        i.classList.remove('selected');
      });
      this.classList.add('selected');

      // Close dropdown
      this.closest('.rc-dropdown-menu').classList.remove('open');

      // Apply filters
      applyFilters();
    });
  });

  /**
   * Apply all active filters
   */
  function applyFilters() {
    var hasActiveFilter = activeFilters.category || activeFilters.material || activeFilters.price;

    // Toggle filtered state (hides sidebar)
    if (hasActiveFilter) {
      collectionGrid.classList.add('filtered');
      clearFiltersBtn.style.display = 'inline-block';
    } else {
      collectionGrid.classList.remove('filtered');
      clearFiltersBtn.style.display = 'none';
    }

    // Get all products as array
    var allRows = Array.from(productRows);

    // Reset visibility on original rows
    allRows.forEach(function(row) {
      row.classList.remove('hidden');
    });
    sections.forEach(function(section) {
      section.classList.remove('hidden');
    });

    // Step 1: Mark rows as hidden based on category filter
    if (activeFilters.category) {
      allRows.forEach(function(row) {
        if (row.dataset.collection !== activeFilters.category) {
          row.classList.add('hidden');
        }
      });
    }

    // Step 2: Mark rows as hidden based on material filter
    if (activeFilters.material) {
      var allowedTests = materialTestLists[activeFilters.material] || [];
      allRows.forEach(function(row) {
        var handle = row.dataset.productHandle || '';
        // Check if product handle matches any test in the allowed list
        var isAllowed = allowedTests.some(function(testId) {
          return handle.indexOf(testId) !== -1;
        });
        if (!isAllowed) {
          row.classList.add('hidden');
        }
      });
    }

    // Get the filtered (visible) rows
    var visibleRows = allRows.filter(function(row) {
      return !row.classList.contains('hidden');
    });

    var visibleCount = visibleRows.length;

    // Step 3: Handle display - either sorted flat list or grouped sections
    var productList = document.querySelector('.rc-product-list');
    var sortedContainer = document.getElementById('rc-sorted-products');

    if (activeFilters.price) {
      // Price sorting - show flat sorted list

      // Sort visible rows by price
      visibleRows.sort(function(a, b) {
        var priceA = parseInt(a.dataset.price) || 0;
        var priceB = parseInt(b.dataset.price) || 0;
        if (activeFilters.price === 'low-high') {
          return priceA - priceB;
        } else {
          return priceB - priceA;
        }
      });

      // Hide all sections
      sections.forEach(function(section) {
        section.classList.add('hidden');
      });

      // Create sorted container if needed
      if (!sortedContainer) {
        sortedContainer = document.createElement('div');
        sortedContainer.id = 'rc-sorted-products';
        sortedContainer.className = 'rc-sorted-products';
        productList.appendChild(sortedContainer);
      }
      sortedContainer.innerHTML = '';
      sortedContainer.style.display = 'flex';

      // Clone and add sorted rows
      visibleRows.forEach(function(row) {
        var clone = row.cloneNode(true);
        clone.classList.remove('hidden');

        // Re-attach click handlers
        clone.addEventListener('click', function(e) {
          if (e.target.closest('button')) return;
          var handle = clone.dataset.productHandle;
          if (handle) rcShowDetails(handle);
        });

        // Re-attach button handlers
        var detailsBtn = clone.querySelector('.rc-btn-details');
        if (detailsBtn) {
          detailsBtn.onclick = function() { rcShowDetails(clone.dataset.productHandle); };
        }

        var cartBtn = clone.querySelector('.rc-btn-cart');
        if (cartBtn) {
          var productData = products.find(function(p) { return p.handle === clone.dataset.productHandle; });
          if (productData) {
            cartBtn.onclick = function() { rcAddToCart(productData.variant_id); };
          }
        }

        sortedContainer.appendChild(clone);
      });

    } else {
      // No price sorting - show grouped sections

      // Hide sorted container
      if (sortedContainer) {
        sortedContainer.style.display = 'none';
      }

      // Hide sections that have no visible products
      sections.forEach(function(section) {
        var sectionRows = section.querySelectorAll('.rc-product-row:not(.hidden)');
        if (sectionRows.length === 0) {
          section.classList.add('hidden');
        }
      });
    }

    // Update count
    if (productCountEl) {
      productCountEl.textContent = visibleCount + ' tests';
    }
  }

  /**
   * Clear all filters
   */
  window.rcClearFilters = function() {
    activeFilters = { category: '', material: '', price: '' };

    // Reset button states
    document.querySelectorAll('.rc-filter-btn').forEach(function(btn) {
      btn.classList.remove('active');
    });

    // Reset selected states
    document.querySelectorAll('.rc-dropdown-item').forEach(function(item) {
      item.classList.remove('selected');
      if (item.dataset.value === '') {
        item.classList.add('selected');
      }
    });

    // Apply (resets everything)
    applyFilters();
  };

  /**
   * Get material options for a package
   */
  function getPackageMaterialOptions(handle) {
    for (var key in packageMaterialOptions) {
      if (handle.indexOf(key) !== -1) {
        return packageMaterialOptions[key];
      }
    }
    return [];
  }

})();
